module.exports = __webpack_public_path__ + "static/media/country_fj.3c89bdeb.webp";